import React from 'react';
import { styled } from '@linaria/react';

const Container = styled.div<CellProps>`
  height: 100%;
  min-width: 0;
  grid-column-end: ${(props) => `span ${props.width}`};
  grid-row-end: ${props => `span ${props.height}`};
  ${props => props.middle ? (
    `
      display: inline-flex;
      flex-flow: column wrap;
      justify-content: center;
      justify-self: stretch;
    `
  ) : ''}
  ${props => props.area ? `grid-area: ${props.area};` : ''}
  ${props => props.center ? `text-align: center;` : ''}
  ${props => props.left ? `grid-column-start: ${props.left}` : ''}
  ${props => props.top ? `grid-row-start: ${props.top}` : ''}
`

export interface CellProps {
  className: string;
  width: number;
  height: number;
  top?: string | number | undefined;
  left?: string | number | undefined;
  middle: boolean;
  center: boolean;
  area?: string | undefined;
  children?: React.ReactNode;
}

function Cell({ children, className, ...props }: CellProps) {
  return <Container className={className} { ...props }>
    {children}
  </Container>;
};

Cell.defaultProps = {
  width: 1,
  height: 1,
  className: '',
  middle: false,
  center: false
}

export default Cell;
